export function scrollTable() {
  const tables = document.querySelectorAll(".js-table-scroll");
  if (tables.length) {
    tables.forEach((table) => {
      const tableContainer = document.createElement("div");
      tableContainer.classList.add("table-container");
      table.parentNode.insertBefore(tableContainer, table);
      tableContainer.appendChild(table);

      let hintDismissed = false; // ヒントが一度非表示にされたかどうかを追跡するフラグ
      let lastWindowWidth = window.innerWidth; // 最後に確認したウィンドウの幅

      const updateTableHintVisibility = () => {
        const tableHint = tableContainer.querySelector(".c-scroll-table__hint") || document.createElement("div");
        if (tableContainer.offsetWidth < table.offsetWidth && !hintDismissed) {
          if (!tableHint.classList.contains("c-scroll-table__hint")) {
            tableHint.classList.add("c-scroll-table__hint");
            tableHint.textContent = "横スクロールできます";
            tableContainer.appendChild(tableHint);
          }
          tableHint.style.display = ""; // hintを表示
        } else {
          tableHint.style.display = "none"; // hintを非表示
        }
      };

      updateTableHintVisibility();

      window.addEventListener("resize", () => {
        if (lastWindowWidth !== window.innerWidth) {
          // 実際にウィンドウの幅が変わったかチェック
          hintDismissed = false; // 画面の幅が変わった場合のみフラグをリセット
          updateTableHintVisibility();
          lastWindowWidth = window.innerWidth; // 現在のウィンドウ幅を記録
        }
      });

      tableContainer.addEventListener("scroll", () => {
        const tableHint = tableContainer.querySelector(".c-scroll-table__hint");
        if (tableHint) {
          tableHint.style.display = "none";
          hintDismissed = true; // テーブルがスクロールされたらフラグを設定
        }
      });
    });
  }
}
